import { render } from "./edit-billing.vue?vue&type=template&id=ddd59218"
import script from "./edit-billing.vue?vue&type=script&lang=js"
export * from "./edit-billing.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__